// Scrolls the window to the top
export function scrollWindowToTop() {
  window.scrollTo({
    behavior: 'smooth',
    top: 'top',
    left: 'left',
  });
}
